import { RequestOptions } from '@/types/Request'
import { request, ORIGIN } from '@/request/RequestWrapper'
import { queryStringBuilder } from '@/utils/util'
import { TaskFilter } from '@/types/Task'

/**
 * 删除任务
 * @param loadingTarget 要显示 loading 的元素
 * @param id 任务 ID
 * @param requestOptions 请求选项
 */
function deleteTask (loadingTarget: HTMLElement | null, id: string, requestOptions: RequestOptions = {}) {
  const url = `${ORIGIN}/TaskManagement/deleteTaskByJobId`
  const options = {
    body: `job_id=${id}`
  }
  const messages = {
    success: 'task deleted',
    error: 'fail to delete task'
  }
  const params = { url, loadingTarget, messages, options, ...requestOptions }
  return request(params)
}

/**
 * 获取全部任务记录
 * @param loadingTarget 要显示 loading 的元素
 * @param task_filter
 * @param requestOptions 请求选项
 */
// eslint-disable-next-line camelcase
function getAllTasks (loadingTarget: HTMLElement | null, task_filter: TaskFilter, requestOptions: RequestOptions = {}) {
  // eslint-disable-next-line camelcase
  const url = `${ORIGIN}/TaskManagement/getTasks`
  const options = {
    body: queryStringBuilder(arguments[1])
  }
  const messages = {
    error: 'get tasks error'
  }
  const params = { url, loadingTarget, messages, options, ...requestOptions }
  return request(params)
}

/**
 * 取消任务
 * @param loadingTarget 要显示 loading 的元素
 * @param id 任务 ID
 * @param requestOptions 请求选项
 */
function cancelTask (loadingTarget: HTMLElement | null, id: string, requestOptions: RequestOptions = {}) {
  const url = `${ORIGIN}/TaskManagement/cancelTaskByJobId`
  const options = {
    body: `job_id=${id}`
  }
  const messages = {
    success: 'task canceled',
    error: 'fail to cancel task'
  }
  const params = { url, loadingTarget, messages, options, ...requestOptions }
  return request(params)
}

export { deleteTask, getAllTasks, cancelTask }
